import { ContainerModule, inject, injectable } from 'inversify';
import { DefaultSeoProps } from 'next-seo';
import { ISeoService } from '@framework/seo/ISeoService';
import { TYPES as SEO_TYPES } from '@framework/seo/types';
import { DomainConfig } from '@framework/config/DI/domainModule/DomainConfig';
import { TYPES } from '@framework/config/DI/types';
import type { IConfig } from '@creditflowresearch/config';
import creditFlow1 from '@/creditflowresearch/ui/components/staticPages/Company/OurSolutions/assets/creditFlow1.webp';

@injectable()
export class SeoService implements ISeoService {
  private readonly description = 'Supersonic Insights and Analysis for Debt Capital Markets.';

  constructor(
    @inject(TYPES.DomainConfig) private domain: DomainConfig,
    @inject(TYPES.AppConfig) private readonly config: IConfig,
  ) {}

  get name(): string {
    return this.config.name;
  }

  getAppTitle(title: string): string {
    if (!title) return this.name;

    return title.includes(this.name) ? title : `${ title } | ${ this.name }`;
  }

  getDefaultSeoConfig(): DefaultSeoProps {
    return {
      title: this.name,
      description: this.description,
      openGraph: this.buildOpenGraphConfig(),
    };
  }

  private buildOpenGraphConfig(): DefaultSeoProps['openGraph'] {
    return {
      url: `${ this.domain.protocol }//${ this.config.hostname }`,
      title: this.name,
      description: this.description,
      type: 'website',
      site_name: this.name,
      images: [
        {
          url: creditFlow1.src,
          width: 800,
          height: 600,
          alt: this.name,
          type: 'image/webp',
        },
      ],
    };
  }
}

export const seoModule = new ContainerModule(({ bind }) => {
  bind<ISeoService>(SEO_TYPES.SeoService).to(SeoService).inSingletonScope();
});

export default seoModule;
